






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Assets from '@/constants/assets';
import UtilsService from '@/core/services/utils.service';

@Component({
  computed: {
    ...mapGetters ({
      openNavbar: 'isOpenNavbar',
      scrollTop: 'scrollTop',
    }),
  },
  components: {
    Icon,
  },
})
export default class TopBar extends Vue {
  @Prop({ default() { return ''; } }) private sectionComeBack!: string;
  @Prop({ default() { return { name: 'root', params: {} }; } }) private backParams: object|undefined;
  @Prop() private phantom!: boolean;
  @Prop( { default: false } ) private withModal!: boolean;
  @Prop( { default: false } ) private modalOpened!: boolean;
  @Prop( { default: true }) private borderTop!: boolean;
  @Prop( { default: false } ) private showPrevAndNext!: boolean;
  @Prop({ default() { return { name: 'root', params: {} }; } }) private prev!: object;
  @Prop({ default() { return { name: 'root', params: {} }; } }) private next!: object;

  private assets = Assets;
  private utilsService = UtilsService;
  private topDistance: number = 8;
  private iconEnum = IconEnum;
  private animateScrollData = {
    currentTime: 0,
    start: 0,
    increment: 20,
    change: 0,
    duration: 500,
  };
  private scrollTop!: any;

  get showComeBack() {
    return !this.phantom && (this.backParams &&  (this.backParams as any).name !== 'root');
  }

  get scrolled() {
    const scrolled = (!this.phantom && this.scrollTop > 0);
    this.$emit('top-bar-scrolled', scrolled);
    return scrolled;
  }

  get openedWithModal() {
    return this.withModal && this.modalOpened;
  }

  get prevDisabled() {
    return JSON.stringify((this.prev as any).params).includes('default');
  }

  get nextDisabled() {
    return JSON.stringify((this.next as any).params).includes('default');
  }

  private goUp() {
    this.animateScrollData.currentTime = 0;
    this.animateScrollData.start = this.scrollTop;
    this.animateScrollData.change = -1 * this.scrollTop;
    this.animateScroll();
  }

  private animateScroll() {
      this.animateScrollData.currentTime += this.animateScrollData.increment;
      const newScrollTop = this.utilsService.easeInOutQuad(
        this.animateScrollData.currentTime,
        this.animateScrollData.start,
        this.animateScrollData.change,
        this.animateScrollData.duration,
      );
      this.$store.dispatch('setScrollTop', newScrollTop);
      if ( this.animateScrollData.currentTime < this.animateScrollData.duration ) {
          setTimeout(() => {
            this.animateScroll();
          }, this.animateScrollData.increment);
      }
  }
}
